import { useQueries, useQuery } from 'react-query'
import { ProductCategoriesApi } from 'types/api/product'
import axios from 'lib/axiosConfigWithoutHumps'

export const useGetCategorisationInfo = () => {
  const {
    isLoading,
    error,
    data: response,
  } = useQuery(
    ['getCategoryTrees'],
    async () => axios.get('/v1/category-trees'),
    {
      keepPreviousData: true,
    }
  )

  const categoryTrees =
    response?.data?.data?.categoryTree.map(
      (category: { categoryTreeName: string }) => category.categoryTreeName
    ) || []

  const categoryInfo = useQueries(
    categoryTrees.map((categoryName: string) => ({
      queryKey: ['getCategoryInfo', categoryName],
      // products/${id} can't use uuid or id, old implementation filters by gtins
      queryFn: async () =>
        axios.get(`/v1/category-trees/${categoryName}`, {
          params: { page_size: 5000 },
        }),
      enabled: Boolean(categoryName),
    }))
  )
  const categoryInfoError = categoryInfo.some((q) => q.error)
  const isLoadingCategoryInfo = categoryInfo.some((q) => q.isLoading)
  const categorisationInfo =
    !categoryInfoError && !isLoadingCategoryInfo
      ? (categoryInfo as ProductCategoriesApi[]).flatMap(
          (q: ProductCategoriesApi) => {
            if (q.data === undefined) return []
            return {
              tree: q.data.config.url.split('/').at(-1) || '',
              categories: q.data?.data.data.category,
            }
          }
        )
      : []
  return { categorisationInfo, isLoading, error }
}
